import { useEffect, useState, useContext } from "react";
import Select from 'react-select';
import { ddStyles, ddStylesSmall } from "../utils/CommonStyles.js";
import FetchUtil from "../utils/FetchUtil";
import UserContext from "../contexts/UserContext";

let productOptions = [];
let delegateOptions = [];

function UserDelegateProductTableRow({ index, userDelegates, companyId, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [userDelegateLoaded, setUserDelegateLoaded] = useState(false);
	const [userDelegateSelected, setUserDelegateSelected] = useState({ name: "delegateKey", label: "", value: "0-0-0-0" });
	const [productLoaded, setProductLoaded] = useState(false);
	const [productSelected, setProductSelected] = useState({ name: "companyProductKey", label: "", value: "0-0" });
	const [isSubmit, setIsSubmit] = useState(false);
	const [isProductLoading, setIsProductLoading] = useState(false);
	const userCtx = useContext(UserContext);
	
	let userCompanyId = userCtx.userCompanyId;
	useEffect(() => {
		setUserDelegateValues(userDelegates);
	}, []);

	function setUserDelegateValues(delegateObj) {
		let delegateValue = {};
		delegateOptions = [];
		if (delegateObj && delegateObj.length > 0) {
			delegateObj.map((aDelegate, idx) => {
				delegateValue.label = aDelegate.parentCompanyName;
				delegateValue.value = aDelegate.userDelegateKey + "-" + aDelegate.companyId + "-" + aDelegate.buyerKey + "-" + aDelegate.level;
				delegateOptions.push(delegateValue);
				delegateValue = {};
			});
			setUserDelegateLoaded(true);
		}
	}
	const delegateHandler = (selectedOption, action) => {
		let delegateKeys = selectedOption ? selectedOption.value : 0;
		let delegateLabel = selectedOption ? selectedOption.label : "";
		setUserDelegateSelected({ ...userDelegateSelected, label: (delegateLabel), value: delegateKeys });
		fetchDelegateProducts(delegateKeys);
	}
	const productHandler = (selectedOption, action) => {
		let productKey = selectedOption ? selectedOption.value : 0;
		let productName = selectedOption ? selectedOption.label : "";
		setProductSelected({ ...productSelected, label: (productName), value: productKey });
	}

	function fetchDelegateProducts(delegateValues) {
		setError("");
		let delegateValueArr=[];
		let buyerKey = 0;
		let level = 0;
		let delegateCompanyId = 0;
		if(delegateValues){
			delegateValueArr = delegateValues.split("-");
		}
		if(delegateValueArr.length >= 4){
			delegateCompanyId = delegateValueArr[1];
			buyerKey = delegateValueArr[2];
			level = delegateValueArr[3];
		}
		if ((!companyId || companyId === 0)) {
			setError(t("error.indirectBuyer.Reqd"));
			return;
		} else if ((!buyerKey || buyerKey === 0)) {
			setError(t("error.buyer.Reqd"));
			return;
		} else if(delegateCompanyId === 0){
			setError(t("error.delegateKeyReqd"));
			setIsSubmit(false);
		}
		setProductValues([]);
		setIsProductLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: false,
				indirectBuyerKey: companyId,
				buyerKey: buyerKey,
				level: level,
				companyKey: delegateCompanyId,
			}),
		};
		try {
			FetchUtil.fetchAPI("GetDelegateProducts", "/Service/CompanyService/GetDelegateProducts", requestOptions, 
			fetchDelegateProductSuccess, fetchDelegateProductFail);
		} catch (error) {
			setIsProductLoading(false);
			throw new Error(error.message);
		}
	}

	function fetchDelegateProductFail(redirect) {
		setIsProductLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.delegateProductNotRetrieved"));
	}

	function fetchDelegateProductSuccess(responseData) {
		let getDelegateProductResponse;
		if (responseData) {
			getDelegateProductResponse = responseData.getDelegateProductResponse;
			if (getDelegateProductResponse && getDelegateProductResponse.errorCode === "0") {
				setProductValues(getDelegateProductResponse.products.slice());
			} else if (getDelegateProductResponse && getDelegateProductResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getDelegateProductResponse) {
				setError(t("error.error") + " " + getDelegateProductResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsProductLoading(false);
	}

	function setProductValues(productObj) {
		let productValue = {};
		productOptions = [];
		productOptions.push({ label: "", value: 0 });
		if (productObj && productObj.length > 0) {
			productObj.map((aProduct, idx) => {
				productValue.label = aProduct.commodityName + ", " + aProduct.productName + (aProduct.productSku ? (", " + aProduct.productSku) : "");
				productValue.value = aProduct.delegateProductKey + "-" + aProduct.companyProductKey;
				productOptions.push(productValue);
				productValue = {};
			});
			setProductLoaded(true);
		}
	}


	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let productValues = productSelected.value;
		let productValArr = [];
		
		let initialValues = {
			companyProductKey: 0,
			delegateProductKey: 0,
			userDelegateKey: 0,
			delegateCompanyId: 0,
			buyerKey: 0,
			level:0
		};
		let delegateValues = userDelegateSelected.value;
		let delegateValueArr = [];
		if(delegateValues){
			delegateValueArr = delegateValues.split("-");
		}
		if(delegateValueArr.length >= 4){
			initialValues.userDelegateKey = delegateValueArr[0];
			initialValues.delegateCompanyId =  delegateValueArr[1];
			initialValues.buyerKey = delegateValueArr[2];
			initialValues.level = delegateValueArr[3];
		} 
		if(productValues){
			productValArr = productValues.split("-");
		}
		if(productValArr.length >= 2){
			initialValues.delegateProductKey = productValArr[0];
			initialValues.companyProductKey = productValArr[1];
		}
		if (initialValues.userDelegateKey === 0) {
			setError(t("error.userDelegateKeyReqd"));
			setIsSubmit(false);
		} else if(initialValues.delegateCompanyId === 0){
			setError(t("error.delegateKeyReqd"));
			setIsSubmit(false);
		} else if(initialValues.buyerKey === 0){
			setError(t("error.buyer.Reqd"));
			setIsSubmit(false);
		} else if (initialValues.companyProductKey === 0) {
			setError(t("error.prodName"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
		setUserDelegateSelected({ name: "delegateKey", label: "", value: "0-0-0-0" });
		setProductSelected({ name: "companyProductKey", label: "", value: "0-0" });
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{userDelegateLoaded ? <Select
					name="delegateKey"
					options={delegateOptions}
					onChange={delegateHandler}
					placeholder={""}
					value={userDelegateSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="delegateKey-input"
					styles={ddStylesSmall}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{productLoaded ? <Select
					name="companyProductKey"
					options={productOptions}
					onChange={productHandler}
					placeholder={""}
					value={productSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="companyProductKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(productOptions && productOptions.length >0 && delegateOptions && delegateOptions.length >0) ?
				(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>) 
				:
				(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default UserDelegateProductTableRow;